import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type {
  ExternalProviderRepository,
  SubmitEvaluationBody,
} from "@shared-kernel/application/ports/external-provider/external-provider-repository";

interface SubmitEvaluationCommand {
  participationId: string;
  body: SubmitEvaluationBody;
  externalProviderRepository: ExternalProviderRepository;
}

export const submitExternalProviderEvaluation = createApiThunk<void, SubmitEvaluationCommand>(
  "externalProvider/submitEvaluation",
  async ({ participationId, body, externalProviderRepository }) => {
    return externalProviderRepository.submitEvaluation(participationId, body);
  },
);

export const resetSubmitExternalProviderEvaluation = createAction("externalProvider/resetSubmitEvaluation");
